import React from 'react'
import { Link } from 'react-router-dom'
import { Card } from './index'

const List = ({embed, data, bookmark}) => {
  return (
    <div className={`flex flex-wrap ${embed ? 'lg:-mx-4' : 'lg:-mx-4'}`}>
      {
        data &&
        data.map((d, index) => {
          return (
            <div className={`w-full ${embed ? 'lg:w-1/2 lg:px-4' : 'lg:w-1/2 lg:px-4'} mb-8`} key={index}>
              <Link to={`/organization/${d.id}/detail`} className="no-tap-highlight">
                <Card embed={embed} key={index} data={d} bookmark={bookmark}/>
              </Link>
            </div>
          )
        })
      }
    </div>
  )
}

export { List }
